import React, { useCallback, useEffect, useState, ChangeEvent } from 'react'

import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'

import {
  ILayout_Editor,
  ILayout_Cell_Props_HTML,
} from '@kaidam/fc-shared/src/types/layout'

import TinyButton from '../../widgets/TinyButton'
import Window from '../../dialog/Window'

/*

  EDITOR

*/

const HTMLEditor: ILayout_Editor<ILayout_Cell_Props_HTML> = ({
  cell,
  triggerEdit,
  onChange,
}) => {

  const [ editing, setEditing ] = useState(false)
  const [ editingHTML, setEditingHTML ] = useState('')

  const {
    html,
  } = cell.data

  const onEdit = useCallback(async () => {
    setEditingHTML(html)
    setEditing(true)
  }, [
    html,
  ])

  const onSubmit = useCallback(async () => {
    let update: Partial<ILayout_Cell_Props_HTML> = {
      html: editingHTML,
    }
    onChange(update)
    setEditing(false)
    setEditingHTML('')
  }, [
    editingHTML,
  ])

  useEffect(() => {
    if(triggerEdit) onEdit()
  }, [
    triggerEdit,
  ])

  return (
    <Box>
      {/* <TinyButton
        size="small"
        color="secondary"
        onClick={ onEdit }
      >
        HTML
      </TinyButton> */}
      {
        editing && (
          <Window
            open
            size="sm"
            onSubmit={ onSubmit }
            withCancel
            onCancel={ () => {
              setEditing(false)
            }}
          >
            <TextField
              fullWidth
              label="HTML code"
              helperText="enter the HTML you want to render in this cell"
              multiline
              rows={10}
              value={ editingHTML }
              onChange={ (e: ChangeEvent<HTMLInputElement>) => {
                setEditingHTML(e.target.value)
              }}
            />
          </Window>
        )
      }
    </Box>
  )
}

export default HTMLEditor